import { Spinner } from "@nextui-org/react";

export const TinyLoadingIcon = ({ className }) => (
    <div className=" flex w-full items-center justify-center">
        <Spinner
            classNames={{
                wrapper: `${className ? className : "!size-20"}`,
                circle1: "border-b-primaryBg border-b-4",
                circle2: "border-b-primaryBg border-b-4",
                label: "text-primaryText",
            }}
        />
    </div>
)